module.exports = __webpack_public_path__ + "static/img/Cancer.20e69b5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/horoscope_icon/Cancer.svg
// module id = 368
// module chunks = 0